import * as THREE from 'three'

const renderer = new THREE.WebGLRenderer({ antialias: true })
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setClearColor(0x286fbb, 1.0)
renderer.setPixelRatio(window.devicePixelRatio)
//renderer.setClearColor(0xffffff, 1.0)

export default renderer